import axiosPost from '../axiosPost';

export const feriadosGet = async (arg) => {
    const { params } = arg;
    const body = {
        "service": "FeriadoGet",
        "params": params ? params : {}
    }
    
    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } 
    catch (err) {
        console.log(err)
    };
};